import { SxProps, Theme, Typography, TypographyPropsVariantOverrides } from '@mui/material'
import { Variant } from '@mui/material/styles/createTypography'
import { OverridableStringUnion } from '@mui/types'
import React from 'react'

type LabelProps = {
  text?: string | React.ReactNode
  v?: OverridableStringUnion<Variant | 'inherit', TypographyPropsVariantOverrides>
  c?: any
  bold?: boolean
  flexGrow?: boolean
  sx?: SxProps<Theme>
  color?: string
  noWrap?: boolean
}

const Label: React.FC<LabelProps> = ({ text, v, c, flexGrow, bold, sx, color, noWrap }) => {
  return (
    <Typography
      variant={v}
      component={c}
      {...(flexGrow ? { flexGrow: 1 } : undefined)}
      sx={sx}
      color={color}
      noWrap={noWrap}
    >
      {bold ? <b>{text}</b> : text}
    </Typography>
  )
}

export default Label
